import { Box, Chip, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useHistory } from "react-router-dom";
import Progress from "components/stamp/progress";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme, props) => ({
  stamp: {
    "& .stamp-wrap": {
      // margin: `${rem(-9)} 0`,
      width: "100%",
      "& .stamp-item": {
        "& .header": {
          paddingRight: rem(20),
        },
        "& .type-stamp": {
          "& .MuiGrid-container": {
            margin: 0,
          },
          "& .MuiButton-root": {
            marginTop: rem(40),
            gap: rem(20),
          },
          "& .detail-btn": {
            fontSize: rem(14),
            marginTop: rem(22),
            textDecoration: "underline",
            textUnderlinePosition: "under",
          },
        },
      },
    },
  },
}));

export default function Stamp(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [stampList, setStampList] = useState([]);
  const [stampClubList, setStampClubList] = useState([]);
  const [fetching, setFetching] = useState(true);

  const fetchData = () => {
    return new Promise((resolve) => {
      setFetching(true);
      axios
        .get("/api/eh/stamp", {
          params: {
            schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
            storeCode: storeCode ? storeCode : "ALL",
          },
        })
        .then((res) => {
          setStampList(res.data.data.stampList);
          if (favInfo && favInfo.visibleTp == 1) {
            setStampClubList(res.data.data.stampClubList);
          } else {
            setStampClubList([]);
          }
          setFetching(false);
          resolve(res.data.data);
        })
        .catch((error) => {
          setFetching(false);
        });
    });
  };

  useEffect(() => {
    setFetching(true);
    fetchData();
  }, []);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "스탬프", menu: true }));
  }, [init]);

  const stampRender = (item) => {
    let render = []; //return
    let dailyMaxCount = item.accCount; //스탬프 최대 갯수
    let gIndex = 0; //giftList index
    let tmCnt = Number(item.totalMaxCount);
    let addCnt = tmCnt === "17" || tmCnt === "27" ? 2 : 0;
    //17, 27개일 경우 2개 더 추가해주기 위한 cnt
    let giftList = item.stampGifts;
    let stampCnt = 0;

    for (let i = 1; i <= tmCnt + addCnt; i++) {
      if (tmCnt === "17" || tmCnt === "27") {
        if (i == 1 || i == 5) {
          render.push(<Grid item key={i} />);
          continue;
        } else {
          stampCnt++;
          render.push(
            <Grid item className={dailyMaxCount > 0 ? "on" : ""} key={i}>
              <div
                className="stamp"
                style={{
                  backgroundImage:
                    dailyMaxCount > 0
                      ? `${"url(" + item.actvImgUrl + ")"}`
                      : `${"url(" + item.dsblImgUrl + ")"}`,
                }}
              />
              {stampCnt == giftList[gIndex].stamp ? (
                <span
                  className="benefit"
                  style={{
                    border: dailyMaxCount > 0 ? `1px solid ${item.clr}` : "",
                    color: dailyMaxCount > 0 ? `${item.clr}` : "",
                  }}
                >
                  {giftList[gIndex].giftFlag == "1"
                    ? giftList[gIndex].dcFlag == "1"
                      ? giftList[gIndex].couponAmount + "원"
                      : giftList[gIndex].couponAmount + "%"
                    : giftList[gIndex].giftProduct + "P"}
                </span>
              ) : (
                ""
              )}
            </Grid>
          );
        }
      } else {
        stampCnt++;
        render.push(
          <Grid item className={dailyMaxCount > 0 ? "on" : ""} key={i}>
            <div
              className="stamp"
              style={{
                backgroundImage:
                  dailyMaxCount > 0
                    ? `${"url(" + item.actvImgUrl + ")"}`
                    : `${"url(" + item.dsblImgUrl + ")"}`,
              }}
            />
            {stampCnt == giftList[gIndex].stamp ? (
              <span
                className="benefit"
                style={{
                  border: dailyMaxCount > 0 ? `1px solid ${item.clr}` : "",
                  color: dailyMaxCount > 0 ? `${item.clr}` : "",
                }}
              >
                {giftList[gIndex].giftFlag == "1"
                  ? giftList[gIndex].dcFlag == "1"
                    ? giftList[gIndex].couponAmount + "원"
                    : giftList[gIndex].couponAmount + "%"
                  : giftList[gIndex].giftProduct + "P"}
              </span>
            ) : (
              ""
            )}
          </Grid>
        );
      }

      if (stampCnt == giftList[gIndex].stamp && gIndex < giftList.length - 1)
        gIndex++;
      dailyMaxCount--;
    }

    return render;
  };

  return (
    <>
      <Loading open={fetching} />
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
        fetchMoreThreshold={50}
      >
        <main id="main" className={"container nopad bg-grey " + classes.stamp}>
          <div className="stamp-wrap">
            <ul>
              {stampClubList.length == 0 && stampList.length == 0 && (
                <>
                  <div className="nodata">
                    <Box className="illust">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                      />
                    </Box>
                    <p className="color-info">
                      진행중인 스탬프 행사가 없습니다
                    </p>
                  </div>
                </>
              )}
              {stampList.map((item, i) => (
                <li
                  key={i}
                  className="stamp-item"
                  onClick={() => {
                    history.push({
                      pathname: `/stamp/detail/${item.seq}`,
                      props: { seq: item.seq, storeCode: storeCode },
                    });
                  }}
                >
                  <div className="header">
                    <div className="store">{item.storeName}</div>
                    <Chip label={"D-" + item.dday} variant="outlined" />
                  </div>

                  <div className="title">
                    <div className="text">
                      {item.promotionSubName}
                      <span className="cnt" style={{ color: item.clr }}>
                        {item.accCount}/{item.totalMaxCount}
                      </span>
                    </div>
                  </div>
                  {item.stampFlag == "1" ? (
                    <div className="type-gauge">
                      <Progress item={item} iconYn="Y" />
                    </div>
                  ) : (
                    <div className="type-stamp">
                      <Grid
                        container
                        spacing={1}
                        className="stamp-grid"
                        justifyContent="center"
                      >
                        {stampRender(item)}
                      </Grid>
                    </div>
                  )}
                </li>
              ))}
            </ul>
            {stampClubList.length > 0 && (
              <Box mt={stampList.length > 0 ? 10 : 0}>
                <div className="club-tit">My 클럽</div>
                <ul>
                  {stampClubList.map((item, i) => (
                    <li
                      key={i}
                      className="stamp-item"
                      onClick={() => {
                        history.push({
                          pathname: `/membership/${item.cd}`,
                          props: { cd: item.cd },
                        });
                      }}
                    >
                      <div className="header">
                        <div className="store">{item.storeName}</div>
                        <Chip label={"D-" + item.dday} variant="outlined" />
                      </div>

                      <div className="title">
                        <div className="text">
                          {item.promotionSubName}
                          <span className="cnt" style={{ color: item.clr }}>
                            {item.accCount}/{item.totalMaxCount}
                          </span>
                        </div>
                      </div>
                      {item.stampFlag == "1" ? (
                        <div className="type-gauge">
                          <Progress item={item} iconYn="Y" />
                        </div>
                      ) : (
                        <div className="type-stamp">
                          <Grid
                            container
                            spacing={1}
                            className="stamp-grid"
                            justifyContent="center"
                          >
                            {stampRender(item)}
                          </Grid>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </Box>
            )}
          </div>
          <Box className="notice is-bottom">
            <p className="title">
              <i className="ico-noti" />
              유의사항
            </p>
            <ul className="list list-dot color-info font-14">
              <li>상세화면에서 응모해야 진행 가능한 스탬프가 있습니다.</li>
              <li>구매 조건이 맞아야 스탬프 1개가 발급됩니다.</li>
            </ul>
          </Box>
        </main>
      </PullToRefresh>
    </>
  );
}
